import React, { useEffect } from 'react';
import { Util, Request, Principal, Scroller, StateProvider, ProxyProvider, childrenText, BAProvider, runtime } from '../../common';
import { InputAdornment, CircularProgress, IconButton, FormControl, InputLabel, FormHelperText } from '@material-ui/core';
import Backdrop, { LoadingSlim } from '../Backdrop';
import { UIComponent } from '../Base';
import { HelpLink } from '../Button';
import Badge from '../Badge';


let validateHandles = [requiredHandle, valueRangeHandle, lengthHandle, variableHandle];

//所有的Input组件，确保set时，是不会触发change事件的
//要触发并且赋值请调用handleChange方法
export class Input extends UIComponent {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      help: null,
      error: null
    }
    // this._reset=false;
  }

  getLabelText() {
    let { label, title } = this.props;
    if (label) return label;
    if (title) return childrenText(title);
    return '';
  }

  tipComponent(componentType, labelSetting, key) {
    labelSetting = labelSetting || {};
    let { ignore, fixed } = labelSetting;
    let { label, title, required } = this.props;
    if (title) return <div key={0} className={`c-input-title mb-2 ${required ? 'c-input-required' : ''} c-${componentType}-title`}>{title}</div>;
    if (!ignore)
      return label ? <InputLabel shrink={true} required={required} className={`c-input-label ${fixed ? 'c-input-label-fixed' : ''} c-${componentType}-label`}>
        {label}
      </InputLabel> : null;
  }

  getClassName(baseClassName) {
    baseClassName = baseClassName || '';
    let { className, size, variant } = this.props;
    className = className || '';
    return `c-input ${variant ? `c-input-${variant}` : ''} ${size ? `c-input-${size}` : ''} ${baseClassName} c-mb-4d5 ${className}`;
  }

  help(msg) {
    if (Util.empty(msg)) return this.state.help || this.props.help;
    else {
      this.setState({ help: msg });
    }
  }

  disabled(b) {
    if (Util.empty(b)) return Util.empty(this.state.disabled) ? this.props.disabled : this.state.disabled;
    this.setState({
      disabled: b
    });
  }

  field() {
    return this.props.field;
  }

  ignoreRecord() {
    return this.props.ignoreRecord;
  }


  getInputProps() {
    let { start, end } = this.props;
    let p = {};
    if (end) {
      p.endAdornment = <InputAdornment position="end">{end}</InputAdornment>;
    }
    if (start) {
      p.startAdornment = <InputAdornment position="start">{start}</InputAdornment>;
    }
    return p;
  }

  getValidateHandles() {
    return validateHandles;
  }

  validate(v) { //常规的验证
    // if (this._reset === true) {
    //   this._reset=false;
    //   this.setState({ error: null});
    //   return;
    // }


    this.setState({ error: null });
    let value = this.getValidateValue(v);  //获得需要验证的值
    let handlers = this.getValidateHandles();
    for (let i = 0; i < handlers.length; i++) {
      let e = handlers[i](this, value);
      if (e) {
        this.setState({ error: e });
        return e;
      }
    }

    if (this.props.validate) {
      let e = this.props.validate(value);
      if (e) {
        this.setState({ error: e });
        return e;
      }
    }

  }

  getValidateValue(v) {
    return Util.invalid(v) ? this.get() : v;
  }

  resetValidate() {
    // this._reset = true;
    this.setState({ error: null });
  }


  defaultErrorMessage(type) {
    switch (type) {
      case "required": return `${this.call()}必填`;
      case "min": {
        let { min } = this.props;
        return `${this.call()}不能小于${min}`;
      }
      case "max": {
        let { max } = this.props;
        return `${this.call()}不能大于${max}`;
      }
    }
  }

  errorMessage(type) {
    let { errorMessage } = this.props;
    if (errorMessage && errorMessage[type]) {
      return errorMessage[type];
    }
    let msg = this.defaultErrorMessage(type);
    if (msg) return msg;
    throw new Error("未能获得错误" + type + "的提示");
  }

  reset() {
    this.resetValidate();
  }


  _renderLabel(content) {
    let { href } = this.props;
    return href ?
      <div className="d-flex flex-row justify-content-start align-items-center">
        {/* <Link href={href}>{content}</Link><HelpLink className="ml-2" size="sm" href={href} /> */}
        <HelpLink className="mr-1 mt-2" size="sm" href={href} />{content}
      </div>
      : content;
  }

  renderHelp(help, className) {
    if (!help) return null;
    if (Util.type(help) === "string") return this._renderLabel(<FormHelperText className={className || ''} dangerouslySetInnerHTML={{ __html: help }}></FormHelperText>);
    return this._renderLabel(help);
  }


  disable(b) {
    this.setState({ disabled: b });
  }

  getDisabled() {
    let { disabled } = this.state;
    if (disabled === true || disabled === false) return disabled;
    return this.props.disabled;
  }

  getTip() {
    let { tip, disabledTip } = this.props;
    if (this.getDisabled() && disabledTip) return disabledTip;
    return tip;
  }

  call() {
    let { label, call } = this.props;
    return call || label || '';
  }


  inputFocus() {  //判定是否有输入焦点
    let active = document.activeElement;
    if (active.tagName === "BODY") return false;
    let self = this.getReceiveFocus ? this.getReceiveFocus() : null;
    if (!self) return false;
    let p = active;
    while (p) {
      if (p === self) return true;
      p = p.parentElement;
    }
    return false;
  }

  handleChange(v) { //基类调用
    this.set(v);
    this.validate(v);
    this.syncDepend(v);
    let { onChange } = this.props;
    if (onChange) onChange(v, { focus: this.inputFocus() });  //当值改变时，组件是否获得了焦点
  }

  componentDidMount() {
    let { depend } = this.props;
    if (!Util.empty(depend)) {
      this.handleChange(depend.value);
    }
  }


  componentWillReceiveProps(nextProps) {
    if (!this.isDependentValueProperty()) return;

    let newValue = nextProps.depend.value;
    let oldValue = this.props.depend.value;
    if (!Util.equals(oldValue, newValue)) {
      if (!Util.empty(newValue)) {
        this.handleChange(newValue);
      }
      else {
        this.reset();
      }
    }
  }

  isDependentValueProperty() {
    return this.props.depend;  //当value设置过值，我们认为是需要开启依赖value来设置值的特性的，这里判断是否设置过值
  }

  syncDepend(value) {
    let { depend } = this.props;
    if (depend) {
      depend.value = value;
    }
  }


}

export function requiredHandle(o, v) {
  let { required, trim } = o.props;
  if (Util.type(v) === "string") {
    if (trim !== false)  //除非指定了不过滤收尾空格，否则默认情况下要过滤
      v = Util.trim(v);
  }
  if (required && Util.empty(v)) {
    return o.errorMessage("required");
  }
}

function valueRangeHandle(o, v) {
  let { max, min } = o.props;
  if (Util.empty(v)) return;
  if (!Util.empty(min) && v < min) return o.errorMessage("min");
  if (!Util.empty(max) && v > max) return o.errorMessage("max");
}

function lengthHandle(o, v) {
  let { minlength, maxlength } = o.props;
  if (Util.empty(v)) return;
  if (!Util.empty(minlength) && v.length < minlength) return o.errorMessage("minlength");
  if (!Util.empty(maxlength) && v.length > maxlength) return o.errorMessage("maxlength");
}

function variableHandle(o, v) {
  if (Util.empty(v)) return;
  let { variable } = o.props;

  if (variable) {
    var reg = /^[0-9a-zA-Z_]{1,}$/;
    if (!reg.test(v))
      return o.errorMessage("variable");
  }
}

function selectionRequiredHandle(o, v) {
  let value, fill;
  if (v && !Util.invalid(v.value)) {
    value = v.value;
    fill = v.fill;
  } else value = v;


  let error = requiredHandle(o, Util.type(value) == "object" ? value.value : value);
  if (error) return error;

  let { options } = o.props;
  if (Util.empty(options) || Util.empty(value)) return null;
  let call = o.call();

  options.forEach((t) => {
    if (t.value == value && t.fill) {
      let { required, minlength, maxlength, trim } = t.fill;

      let localFill = fill;
      if (Util.type(localFill) === "string") {
        if (trim !== false)  //除非指定了不过滤首尾空格，否则默认情况下要过滤
          localFill = Util.trim(localFill);
      }
      if (required && Util.empty(localFill)) {
        error = `${call}的填空必填`
      } else if (maxlength && localFill.length > maxlength) {
        error = `${call}的填空字数不能大于${maxlength}`
      } else if (minlength && localFill.length < minlength) {
        error = `${call}的填空字数不能小于${minlength}`
      }
    }
  })

  return error;
}


export class Selection extends Input {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      value: []
    }
    this.value = [];
  }

  getValidateHandles() {
    return [...validateHandles, selectionRequiredHandle];
  }

  get() {
    return this.value;
  }

  set(v) {
    this.value = v;
    this.setState({ value: v });  //由于setState是异步的，当刚set，马上get就会由于延迟导致bug,所以这里用this.value再次记录
  }

  options(l, cb) {
    if (l) {
      this.__options = l
      this.setState({ options: l }, () => {
        if (cb) cb();
      });
    } else {
      
      if (!Util.empty(this.__options)) return this.__options;
      if (!Util.empty(this.state.options)) return this.state.options;
      if (!Util.empty(this.props.options)) return this.props.options;
      return [];
    }
  }

  addOptions(l) {
    let items = this.options();
    l.forEach((t) => {
      let i = Util.indexOf(items, (item) => item.value == t.value);
      if (i > -1) Util.removeAt(items, i);
      items.push(t);
    });
    this.options(items);
  }

  reset() {
    let v = this.props.value || [];
    this.handleChange(v);
    this.resetValidate();
  }

  defaultErrorMessage(type) {
    let { minlength, maxlength } = this.props;
    let label = this.call();
    switch (type) {
      case "required": return `请选择${label}`;
      case "minlength": {
        return `${label}选择的数量不能小于${minlength}`;
      }
      case "maxlength": {
        return `${label}选择的数量不能大于${maxlength}`;
      }
    }
    return super.defaultErrorMessage(type);
  }

  getOptionHelp(value) {
    let options = this.options();
    if (Util.invalid(value)) return;
    let l = options.filter((p) => p.value == value);
    if (l.length > 0 && l[0].help) return l[0].help;
  }

  // getHelpByOptions(){
  //   let options = this.options();
  //   let value = this.get();
  //   if(Util.invalid(value)) return;
  //   let l = options.filter((p)=>p.value==value);
  //   if(l.length > 0 && l[0].help) return l[0].help;
  // }

  // help(msg) {
  //   if (!Util.empty(msg)) {
  //     super.help(msg);
  //     return;
  //   }
  //   let help = this.getHelpByOptions() || super.help();
  //   if (!help) return '';
  //   let type = Util.type(help);
  //   if (type === "string") return help;
  //   else if (type === "object") {
  //     let value = this.get() || '';
  //     if (Util.type(value) === "array") return '';
  //     return help[value.value || value] || '';  //在group模式下，get获得的value是{value,group}
  //   }

  //   return help;
  // }

  renderInput() {

  }

  renderLoading() {
    let { className } = this.props;
    return <LoadingSlim className={`c-mh2 ${className}`} size="xs" message="加载中" />
  }

  renderMain() {
    let {mobileable} = this.props;
    if(runtime.mobile && mobileable) return this.renderMobile();

    let { error } = this.state;
    let help = this.help();
    let labelSetting = this.labelSetting || {};
    let { variant, width,minWidth,maxWidth } = this.props;
    let style={width,minWidth,maxWidth};
    return (
      <FormControl
        data-gta-container
        data-gta-title={this.getLabelText()}
        variant={variant} 
        style={style}
        className={this.getClassName(`${width ||minWidth || maxWidth? '' : 'w-100'} ${this.baseClassName || ''}`)} 
        error={error ? true : false} disabled={this.getDisabled()} >
        {this.tipComponent("selection", labelSetting)}
        {this.renderInput()}
        {this.renderHelp(error || help)}
      </FormControl>
    )
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadOptions();
  }

  getLoad() {
    let { load } = this.props;
    if (!load) return;
    return Util.type(load) === "function" ? load() : load;
  }

  loadOptions() {
    let load = this.getLoad();
    if (!load) return;
    let my = this;
    let { onLoadOptions } = my.props;

    if (Util.type(load) === "array") {
      //直接返回了选项集合
      let options = load;
      my.loadOptionsEnd(options, () => {
        if (onLoadOptions) onLoadOptions(options);
      });
      return;
    }
    Request.mute({
      ...load,
      url: load.url || load.action,
      success: (r) => {
        let options = r.rows || r.items;
        my.loadOptionsEnd(options, () => {
          if (load.onload) load.onload(options);
          if (onLoadOptions) onLoadOptions(options);
        });
      }
    });
  }

  loadOptionsEnd(options, cb) {
    this.options(options, () => {
      this.setState({
        loading: false
      }, () => {
        let value = this.get();
        if (!Util.invalid(value)) {
          this.handleChange(value);
        }
        if (cb) cb();
      });
    });
  }

  refresh() {
    let my = this;
    my.setState({
      loading: true
    }, () => {
      my.loadOptions();
    });
  }

  render() {
    let load = this.getLoad();
    if (!load) return this.renderMain();
    return this.state.loading === false ? this.renderMain() : this.renderLoading();
  }
}
